<template>
  <div>
    <b-card class="text-center">
      <h5 class="card-title">Información</h5>
      <p>
        <strong>Paciente:</strong> {{ informacionTerapia.primerNombre
        }}{{ informacionTerapia.primerApellido }}
      </p>
      <p><strong>Terapia:</strong> {{ informacionTerapia.terapia }}</p>
    </b-card>

    <div class="row">
      <div
        class="col-sm-6 col-md-4 mb-4"
        v-for="(detalle, index) in detallesTerapia"
        :key="index"
      >
        <b-card>
          <h5 class="card-title">Detalle de Terapia {{ index + 1 }}</h5>
          <p>
            <strong>Fecha:</strong> {{ detalle.detalleTerapia.fechaTerapia }}
          </p>
          <p>
            <strong>Procedimiento Aplicado:</strong>
            {{ detalle.detalleTerapia.procedimientoAplicado }}
          </p>
          <p><strong>Estado:</strong> {{ detalle.detalleTerapia.estado }}</p>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BOverlay,
  BCardGroup,
  BCardText,
  BFormGroup,
  BMedia,
  BAvatar,
  BModal,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormDatepicker,
} from "bootstrap-vue";
import actions from "@/assets/utils/utils";
import BCardCode from "@core/components/b-card-code";
import { comprobarPermisos } from "@/shared/helpers";
import vSelect from "vue-select";
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";

export default {
  components: {
    BCard,
    BCardCode,
    BRow,
    BCardGroup,
    BCardText,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BModal,
    BMedia,
    BAvatar,
    BOverlay,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BFormDatepicker,
    vSelect,
  },
  data() {
    return {
      detallesTerapia: [],
      informacionTerapia: {
        estadoTerapia: "",
        fechaTerapia: "",
        terapia: "",
        codigoTerapia: "",
        
        primerNombre: "",
        primerApellido: "",
      },
    };
  },
  created() {
    const idSolicitudTerapia = this.$route.params.id;
    this.fetchDetalleTerapia(idSolicitudTerapia);
    this.fetchSolicitudTerapiaId(idSolicitudTerapia);
    comprobarPermisos(this.$route);
  },
  methods: {
    async fetchDetalleTerapia(idSolicitudTerapia) {
      const query = `
      query MyQuery {
  detallesSolicitudTerapia(idSolicitudTerapia: "2") {
    message
    status
    detalleTerapia {
      terapiaNut {
        actividadFisica
        cafe
        conclusion
        contextura
        cuidador
        estado
        hidratacion
        horasDescanso
        id
        plantera
        recomendaciones
        tipoDieta
        token
        ultimoCambio
      }
      terapiaPsico {
        aparienciaFisica
        conclusion
        diagnostico
        estado
        examenMental
        experienciasInfancia
        historiaFamiliar
        perfilSocial
        personalidad
        semedica
      }
      fechaTerapia
      estado
      id
      solicitudTerapia {
        id
      }
      urlFirmaPaciente
    }
  }
}
            `;
      const variable = {
        idSolicitudTerapia: idSolicitudTerapia,
      };
      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: variable,
        });
        console.log("yy", response);
        this.detallesTerapia = response.data.data.detallesSolicitudTerapia;
        console.log("Respuesta:", this.detallesTerapia);
      } catch (error) {
        console.error("Error fetching terapias programadas:", error);
      }
    },
    async fetchSolicitudTerapiaId(idSolicitudTerapia) {
      const query = `
            query GetSolicitudTerapia($idSolicitudTerapia: String!) {
                solicitudTerapia(idSolicitudTerapia: $idSolicitudTerapia) {
                    status
                    message
                    solicitudTerapia{
                    id
                    fechaProgramada
                    estadoTerapia
                    terapia{
                        id
                        nombre
                        codigo
                    }
                    consultamedica {
                        cita {
                            paciente {
                                persona {
                                primerNombre
                                primerApellido
                                identificacion
                                }
                            }
                        }
                    }
                    }
                }
            }


            `;
      const variables = {
        idSolicitudTerapia: idSolicitudTerapia,
      };
      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: variables,
        });
        console.log(response);

        if (response.status === 200) {
          console.log(
            response.data.data.solicitudTerapia.solicitudTerapia.terapia.codigo
          );
          this.informacionTerapia.terapia =
            response.data.data.solicitudTerapia.solicitudTerapia.terapia.nombre;
          this.informacionTerapia.codigoTerapia =
            response.data.data.solicitudTerapia.solicitudTerapia.terapia.codigo;
          this.informacionTerapia.fechaProgramada =
            response.data.data.solicitudTerapia.solicitudTerapia.fechaProgramada;
          this.informacionTerapia.id =
            response.data.data.solicitudTerapia.solicitudTerapia.id;
          this.informacionTerapia.primerNombre =
            response.data.data.solicitudTerapia.solicitudTerapia.consultamedica.cita.paciente.persona.primerNombre;
          this.informacionTerapia.primerApellido =
            response.data.data.solicitudTerapia.solicitudTerapia.consultamedica.cita.paciente.persona.primerApellido;
          console.log(
            "respuesta",
            response.data.data.solicitudTerapia.solicitudTerapia.estadoTerapia
          );
          console.log(this.informacionTerapia.codigoTerapia);
        }
      } catch (error) {
        console.error("Error fetching terapias programadas:", error);
        // Aquí también podrías mostrar un mensaje de error en la interfaz de usuario
      }
    },
  },
};
</script>
